import SettingProps from "../SettingProps";
// import CSSSetting from "../csssetting/CSSSetting";
import GenericSetting, {StyleSettingType} from "../genericsetting/GenericSetting";

export default function WidthSetting(props: SettingProps) {
    // return <CSSSetting {...props} title={"Dimension"}  type={"dimension"} targets={["max-width" , "max-height" ,"min-width", "min-height","width","height"]}/>
    return <GenericSetting {...props}
                           title={"Width"}
                           type={"width"}
                           targets={[
                                    { name: "Max Width",target: 'max-width' , type: StyleSettingType.default_and_auto_size},
                                    { name: "Min Width", target: 'min-width' , type: StyleSettingType.default_and_auto_size},
                                    { name: "Width", target: 'width' , type: StyleSettingType.default_and_auto_size},
                                ]}
        />
}